import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthService } from './services/auth/auth.service';

const routes: Routes = [
  { path: '', redirectTo: 'facct', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule) },
  { path: 'facct', loadChildren: () => import('./pages/facct/facct/facct.module').then(m => m.FacctPageModule), canActivate: [AuthService] },


  { path: 'facctpending', loadChildren: () => import('./pages/facct/facctpending/facctpending.module').then(m => m.FaccthistoricalPageModule), canActivate: [AuthService] },
   { path: 'facctnotgde', loadChildren: () => import('./pages/facct/facctnotgde/facctnotgde.module').then(m => m.FacctNotGDEPageModule), canActivate: [AuthService] },

  { path: 'facctcashs-modal', loadChildren: () => import('./pages/facct/facct-modal/facctcashs-modal/facctcashs-modal.module').then(m => m.FacctcashsModalPageModule), canActivate: [AuthService] },

  { path: 'facct-modal', loadChildren: () => import('./pages/facct/facct-modal/facct-modal/facct-modal.module').then(m => m.FacctModalPageModule), canActivate: [AuthService] },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
